import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/Data Transfers/FormData";
import * as React from 'react';
export default {
  Content,
  React
};